/**
 * The /leads action scope as a cross-feature table scope — what contact lists and the CRM transfer
 * accept as `scope` and resolve server-side against the search query.
 *
 * @param {Object} actionScope - Result of useActionScope ({ scope, prospectQueryId })
 * @returns {{table: 'leads', contextId: string, ids?: string[], selectAll?: true, filters?: Object}}
 */
export const toLeadTableScope = ({ scope, prospectQueryId }) => {
	const { leadIds, ...selectAllScope } = scope;
	return { table: 'leads', contextId: prospectQueryId, ...(leadIds ? { ids: leadIds } : selectAllScope) };
};
